function changeLogoColor(color) {
  setupTransitionsIfNeeded();
  const svg = document.querySelector('#Logo_Base');
  const defs = svg.querySelector('defs') || (() => {
    const d = document.createElementNS('http://www.w3.org/2000/svg','defs');
    svg.insertBefore(d, svg.firstChild);
    return d;
  })();
  const gradientId = 'logoGradient';
  let colors = Array.isArray(color) ? color : color.split(',');
  colors = colors.map(c => c.trim());

  if (colors.length === 2) {
    const existing = defs.querySelector('#' + gradientId);
    if (existing) defs.removeChild(existing);
    const grad = document.createElementNS('http://www.w3.org/2000/svg','linearGradient');
    grad.setAttribute('id', gradientId);
    grad.setAttribute('x1','0%');
    grad.setAttribute('y1','0%');
    grad.setAttribute('x2','100%');
    grad.setAttribute('y2','0%');
    [{offset:'0%',color:colors[0]},{offset:'100%',color:colors[1]}].forEach(s => {
      const stop = document.createElementNS('http://www.w3.org/2000/svg','stop');
      stop.setAttribute('offset', s.offset);
      stop.setAttribute('stop-color', s.color);
      grad.appendChild(stop);
    });
    defs.appendChild(grad);
    svg.querySelectorAll('path').forEach(path => {
      path.setAttribute('fill', `url(#${gradientId})`);
    });
  } else {
    svg.querySelectorAll('path').forEach(path => {
      path.setAttribute('fill', colors[0]);
    });
  }

  function hexToRgb(hex) {
    hex = hex.replace('#','');
    if (hex.length === 3) hex = hex.split('').map(c=>c+c).join('');
    const num = parseInt(hex,16);
    return { r: (num>>16)&255, g: (num>>8)&255, b: num&255 };
  }

  function luminance({ r, g, b }) {
    [r, g, b] = [r, g, b].map(v => {
      v /= 255;
      return v <= 0.03928 ? v/12.92 : Math.pow((v+0.055)/1.055, 2.4);
    });
    return 0.2126*r + 0.7152*g + 0.0722*b;
  }

  function pickTextColor(bgColors) {
    const l = bgColors.length === 2
      ? (luminance(hexToRgb(bgColors[0])) + luminance(hexToRgb(bgColors[1]))) / 2
      : luminance(hexToRgb(bgColors[0]));
    return l > 0.5 ? '#000' : '#fff';
  }

  document.querySelectorAll('button[name="add"]').forEach(button => {
    if (colors.length === 2) {
      button.style.backgroundImage = `linear-gradient(to right, ${colors[0]}, ${colors[1]})`;
      button.style.backgroundColor = 'transparent';
    } else {
      button.style.backgroundImage = 'none';
      button.style.backgroundColor = colors[0];
    }
    button.style.color = pickTextColor(colors);
  });
}

let transitionsSetup = false;

function setupTransitionsIfNeeded() {
  if (transitionsSetup) return;
  const style = document.createElement('style');
  style.textContent = `
    #Logo_Base path { transition: fill 0.5s ease-in-out; }
    button[name="add"] { transition: background 0.5s ease-in-out, color 0.5s ease-in-out, border-color 0.5s ease-in-out; }
  `;
  document.head.appendChild(style);
  transitionsSetup = true;
}

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  setupTransitionsIfNeeded();
} else {
  document.addEventListener('DOMContentLoaded', setupTransitionsIfNeeded);
}
